module.exports = __webpack_public_path__ + "static/img/img_requirements.1776169966151.png";